import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("botmoileqi_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

/** Fetch a binary endpoint and return the Blob, using the same auth interceptor as REST calls. */
export const fetchBlob = async (path) => {
    const res = await api.get(path, { responseType: "blob" });
    return res.data;
};

/** Direct URL for an illustration image (public endpoint, no auth needed). */
export const illustrationUrl = (illustrationId) =>
    illustrationId ? `${API_BASE}/illustrations/${illustrationId}/image` : null;

/**
 * WebP redimensionné (?w=…&f=webp, backend/routers/illustrations.py) : le srcset
 * évite de télécharger l'original (60 à 500 Ko) pour une vignette de 400 px.
 * Retourne { src, srcSet } ; `src` reste l'original (navigateurs sans WebP).
 */
export const illustrationWebp = (illustrationId, largeurs = [320, 400, 640]) =>
    illustrationId
        ? {
              src: illustrationUrl(illustrationId),
              srcSet: largeurs
                  .map((w) => `${illustrationUrl(illustrationId)}?w=${w}&f=webp ${w}w`)
                  .join(", "),
          }
        : null;

export const formatApiError = (error, fallback = "Une erreur est survenue.") => {
    const detail = error?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    }
    if (detail && typeof detail === "object" && typeof detail.msg === "string") {
        return detail.msg;
    }
    return error?.message || fallback;
};

export default api;
